angular.module('ums.configuration').constant('dataItemSortingConstant', {
    LABEL_ASC: 0,
    LABEL_DESC: 1,
    VALUE_ASC: 2,
    VALUE_DESC: 3
});
